module.exports = __webpack_public_path__ + "static/img/装饰9.108c5b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰9.svg
// module id = tuJd
// module chunks = 2